export type OrderStatus = 'pending' | 'confirmed' | 'shipping' | 'delivered' | 'cancelled'

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  pending:   'Chờ xác nhận',
  confirmed: 'Đã xác nhận',
  shipping:  'Đang giao',
  delivered: 'Đã giao',
  cancelled: 'Đã hủy',
}

export const ORDER_STATUS_COLOR: Record<OrderStatus, string> = {
  pending:   'bg-amber-100 text-amber-700',
  confirmed: 'bg-blue-100 text-blue-700',
  shipping:  'bg-indigo-100 text-indigo-700',
  delivered: 'bg-green-100 text-green-700',
  cancelled: 'bg-red-100 text-red-700',
}

export interface AdminOrder {
  id: string
  customer: string
  phone: string
  total: number
  status: OrderStatus
  createdAt: string
  itemCount: number
}

export interface TopProduct {
  id: string
  slug: string
  name: string
  image: string
  sold: number
  revenue: number
}

export interface DashboardStats {
  orders: { value: number; delta: number }
  revenue: { value: number; delta: number }
  products: { value: number; delta: number }
  customers: { value: number; delta: number }
}
